import { readLocal, writeLocal } from '../local-store'
import type { GuideItem, Stay } from '../reserva/types'
import type { AfterStay, ChecklistEntry } from './types'

export const CHECKLIST_FIELD = 'checkoutChecklist'

const CHECKOUT_GUIDE_RE = /salida|salir|check.?out/i

/** Ítem de la guía sobre la salida (heurística por nombre, como las instrucciones de entrada, D40). */
export const checkoutGuideItem = (stay: Pick<Stay, 'guide'>): GuideItem | null => [...stay.guide.manual, ...stay.guide.conditions].find((it) => CHECKOUT_GUIDE_RE.test(it.name)) ?? null

export function withChecked(guestCode: string, items: Omit<ChecklistEntry, 'done'>[]): ChecklistEntry[] {
  const done = readLocal<string[]>(guestCode, CHECKLIST_FIELD) ?? []
  return items.map((it) => ({ ...it, done: done.includes(it.id) }))
}

export function saveChecked(guestCode: string, id: string, on: boolean): void {
  const done = new Set(readLocal<string[]>(guestCode, CHECKLIST_FIELD) ?? [])
  if (on) done.add(id)
  else done.delete(id)
  writeLocal(guestCode, CHECKLIST_FIELD, [...done])
}

/** Motor de reservas con `environmentDataId`, como `showGetNewReserve` en la app actual (Home.tsx). */
export function rebookUrl(stay: Pick<Stay, 'flags' | 'environmentId'>): string | null {
  if (!stay.flags.showGetNewReserve || !stay.environmentId) return null
  return `https://bookingengine.availroom.com/?environment=${encodeURIComponent(stay.environmentId)}`
}

export const realRebook = (stay: Pick<Stay, 'flags' | 'environmentId'>): AfterStay['rebook'] => {
  const url = rebookUrl(stay)
  return url ? { url, discountPercent: null, suggestedDates: [] } : null
}
